import { render } from "./context_menu_item.vue?vue&type=template&id=3967d0eb&ts=true"
import script from "./context_menu_item.vue?vue&type=script&lang=ts"
export * from "./context_menu_item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__